/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */

import axios from "axios"
import analytics from "@/service/analytics"

function startZendesk({ appKey, userId, userName, userEmail, clientName }) {
  const script = document.createElement("script")
  const firstScript = document.getElementsByTagName("script")[0]

  script.type = "text/javascript"
  script.id = "ze-snippet"
  script.src = `https://static.zdassets.com/ekr/snippet.js?key=${appKey}`

  script.onload = function() {
    // https://developer.zendesk.com/embeddables/docs/widget/api
    if (!window.zE) {
      console.error("Failed to initialize zendesk")
    } else {
      window.zE(function() {
        window.zE.identify({
          name: userName,
          email: userEmail,
          organization: clientName
        })
      })
    }
  }

  firstScript.parentNode.insertBefore(script, firstScript)
}

function getZendeskInfo() {
  return axios.get("/services/zendesk")
}

export function launchHelp() {
  window.zE.activate()
  analytics.logAnalytic("Views Help")
}

export default function() {
  return getZendeskInfo().then(
    response => startZendesk(response.data || {}),
    error => console.error("Failed to retrieve zendesk info", error)
  )
}



// WEBPACK FOOTER //
// ./src/service/zendesk.js